import { getHomePath } from "@shared/common/node/condition";
import type { ExternalSiteCheckRule } from "../../types";
import { SHOPIFY_PAGE, SITE_TYPE } from "./const";

const shopify: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target, siteUrl, html }) {
    const pwFormHidden = html.querySelector("div#RecoverPasswordForm.hide");

    if (target.value === "HOME" && url.pathname === getHomePath(siteUrl)) {
      return true;
    }

    if (
      target.value === SHOPIFY_PAGE.LOGIN.target &&
      url.pathname === SHOPIFY_PAGE.LOGIN.url
    ) {
      return true;
    }

    if (
      target.value === SHOPIFY_PAGE.SIGNUP.target &&
      url.pathname === SHOPIFY_PAGE.SIGNUP.url
    ) {
      return true;
    }

    // 비밀번호 찾기의 경우 로그인과 같은 경로를 사용하며 뒤에 #recover가 붙는 경우도 있음
    // 로그인과 페이지를 구분하기 위헤 element를 이용해 식별함
    if (target.value === SHOPIFY_PAGE.FIND_PASSWORD.target && !pwFormHidden) {
      if (
        url.pathname === SHOPIFY_PAGE.FIND_PASSWORD.url ||
        url.pathname === SHOPIFY_PAGE.FIND_PASSWORD.url + "#recover"
      ) {
        return true;
      }
    }

    if (
      target.value === SHOPIFY_PAGE.MY_PAGE.target &&
      url.pathname === SHOPIFY_PAGE.MY_PAGE.url
    ) {
      return true;
    }

    if (
      target.value === SHOPIFY_PAGE.CART.target &&
      url.pathname === SHOPIFY_PAGE.CART.url
    ) {
      return true;
    }

    return false;
  },
};

export default shopify;
